module.exports = __webpack_public_path__ + "static/img/center_btn_pay.4efda82b.png";